<div class="fuse-vertical-navigation-item-wrapper mx-3 my-0">
  <button
    class="fuse-vertical-navigation-item mb-1 flex w-full items-center justify-start gap-3 rounded-md bg-[rgba(255,193,7,0.08)] px-3 py-[10px] hover:bg-[rgba(255,193,7,0.16)]"
    (click)="openPremium()"
  >
    <img
      src="/icons/custom/icon-diamond.svg"
      alt="Icon premium"
      class="h-auto w-8"
    />
    <span class="fuse-vertical-navigation-item-title-wrapper">
      <div
        class="fuse-vertical-navigation-item-title text-md font-semibold uppercase leading-5 text-brandSecondary"
      >
        UPGRADE YOUR<br />
        POCKETGUARD
      </div>
    </span>
    <mat-icon
      class="ml-auto text-brandSecondary icon-size-6"
      [svgIcon]="'feather:chevron-right'"
    ></mat-icon>
  </button>
</div>
